import Candidates from "../pages/Candidates";

export default function PortalCandidatesPanel() {
  return (
    <div className="min-h-0 flex-1 bg-[hsl(var(--ds-bg))] text-[hsl(var(--ds-fg))]">
      <Candidates />
    </div>
  );
}
